var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"src":require("../assets/img/shou_ye_bg@2x.png"),"width":"861","height":"491","alt":""}})])
}]

export { render, staticRenderFns }